import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { config, KeyUri } from '../key';

const PreviousRides = ({ userid, onSelectRoute }) => {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserBookings = async () => {
      try {
        const response = await axios.get(`${KeyUri.BACKEND_URI}/get-bookings-user/${userid}`, config);
        setOrders(response.data || []);
      } catch (error) {
        console.error("Error fetching previous rides:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchUserBookings();
  }, [userid]);

  // Get unique routes
  const uniqueRoutesMap = new Map();
  orders.forEach(order => {
    if (order?.route?.name && !uniqueRoutesMap.has(order.route.name)) {
      uniqueRoutesMap.set(order.route.name, order);
    }
  });
  const uniqueRoutes = Array.from(uniqueRoutesMap.values());

  if (isLoading) {
    return <p>Loading previous rides...</p>;
  }

  if (uniqueRoutes.length === 0) {
    return <p>No previous rides found.</p>;
  }

  return (
       <div className="w-full overflow-hidden relative -mb-6">
      {/* Reuse same styles as QuickRoutes */}
      <style>{`
        @keyframes scrollPrev {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .scroll-wrapper-prev {
          display: flex;
          width: max-content;
          animation: scrollPrev 25s linear infinite;
        }
        .scroll-item-prev {
          flex: 0 0 auto;
          margin-right: 1rem;
          padding: 3px 1rem;
          background: #22c55e;
          color: white;
          border-radius: 0.5rem;
          white-space: nowrap;
          cursor: pointer;
          transition: background 0.3s;
        }
        .scroll-item-prev:hover {
          background: #16a34a;
        }
      `}</style>

      <div className="flex">
        <div className="scroll-wrapper-prev">
          {[...uniqueRoutes, ...uniqueRoutes].map((route, index) => (
            <div
              key={`${route._id || route.route?.name}-${index}`}
              onClick={() => onSelectRoute(route)}
              className="scroll-item-prev px-3 py-1"
            >
              {route.route?.name}
            </div>
          ))}
        </div>
      </div>
    </div>

    
  );
};

export default PreviousRides;
